import * as Yup from 'yup'
import { isQSRHClient } from 'setups/controller'
import { projectClient } from 'constants/project'

export const CreateMemberSchemas = Yup.object().shape({
  cardNumber: Yup.string().notRequired().nullable(),
  cardPin: Yup.string().notRequired().nullable(),
  password: isQSRHClient(projectClient)
    ? Yup.string().nullable().notRequired()
    : Yup.string().required('This field is required.').nullable(),
  titleId: Yup.number().nullable().notRequired(),
  firstName: Yup.string().required('This field is required.').nullable(),
  lastName: Yup.string().required('This field is required.').nullable(),
  rankingId: Yup.number().nullable().notRequired(),
  mobile: Yup.string().nullable().notRequired(),
  email: Yup.string().nullable().notRequired(),
  genderId: Yup.number().nullable().notRequired(),
  birthDate: Yup.string().nullable().notRequired(),

  postalAddress: Yup.object().shape({
    address1: Yup.string().nullable().notRequired(),
    address2: Yup.string().nullable().notRequired(),
    address3: Yup.string().nullable().notRequired(),
    address4: Yup.string().nullable().notRequired(),
    suburb: Yup.string().nullable().notRequired(),
    city: Yup.string().nullable().notRequired(),
    state: Yup.string().nullable().notRequired(),
    postcode: Yup.string().nullable().notRequired(),
    countryId: Yup.string().nullable().notRequired(),
  }),

  physicalAddress: Yup.object().shape({
    address1: Yup.string().nullable().notRequired(),
    address2: Yup.string().nullable().notRequired(),
    address3: Yup.string().nullable().notRequired(),
    address4: Yup.string().nullable().notRequired(),
    suburb: Yup.string().nullable().notRequired(),
    city: Yup.string().nullable().notRequired(),
    state: Yup.string().nullable().notRequired(),
    postcode: Yup.string().nullable().notRequired(),
    countryId: Yup.string().nullable().notRequired(),
  }),

  enrollmentTraderId: Yup.number().nullable().notRequired(),
  mailingPreferenceId: Yup.number().nullable().notRequired(),
  custom1: Yup.string().nullable().notRequired(),
  custom2: Yup.string().nullable().notRequired(),
  custom3: Yup.string().nullable().notRequired(),
  website: Yup.string().nullable().notRequired(),
  comments: Yup.string().nullable().notRequired(),
  phone1: Yup.string().nullable().notRequired(),
  phone2: Yup.string().nullable().notRequired(),

  gdpr: Yup.object().shape({
    flOffer: Yup.number().nullable().notRequired(),
    flCompet: Yup.number().nullable().notRequired(),
    flNews: Yup.number().nullable().notRequired(),
    flEmail: Yup.number().nullable().notRequired(),
    flSms: Yup.number().nullable().notRequired(),
    flApp: Yup.number().nullable().notRequired(),
    flTnc: Yup.number().nullable().notRequired(),
    flPrivacy: Yup.number().nullable().notRequired(),
    tncVersion: Yup.string().nullable().notRequired(),
    privacyVersion: Yup.string().nullable().notRequired(),
    consentDate: Yup.string().nullable().notRequired(),
    reasonId: Yup.number().nullable().notRequired(),
  }),
});

export const CreateDrdMemberSchemas = Yup.object().shape({
  firstName: Yup.string().required('This field is required.').nullable(),
  lastName: Yup.string().nullable().notRequired(),
  password: Yup.string().nullable().notRequired(),
  address1: Yup.string().nullable().notRequired(),
  address2: Yup.string().nullable().notRequired(),
  address3: Yup.string().nullable().notRequired(),
  address4: Yup.string().nullable().notRequired(),
  suburb: Yup.string().nullable().notRequired(),
  city: Yup.string().nullable().notRequired(),
  state: Yup.string().nullable().notRequired(),
  postCode: Yup.string().nullable().notRequired(),
  countryId: Yup.string().nullable().notRequired(),
  physicalAddress1: Yup.string().nullable().notRequired(),
  physicalAddress2: Yup.string().nullable().notRequired(),
  physicalAddress3: Yup.string().nullable().notRequired(),
  physicalAddress4: Yup.string().nullable().notRequired(),
  physicalSuburb: Yup.string().nullable().notRequired(),
  physicalCity: Yup.string().nullable().notRequired(),
  physicalState: Yup.string().nullable().notRequired(),
  physicalPostCode: Yup.string().nullable().notRequired(),
  physicalCountryId: Yup.string().nullable().notRequired(),
  custom1: Yup.string().nullable().notRequired(),
  custom2: Yup.string().nullable().notRequired(),
  custom3: Yup.string().nullable().notRequired(),
  comments: Yup.string().nullable().notRequired(),
  ident: Yup.string().required('This field is required.').nullable(),
});